<div class="modal-fade-container" #fadeContainer>
  <div class="button-container">
    <app-button
      [buttonOptions]="{
        fill: false,
        variant: 'link',
      }"
      dataLabel="close"
      class="mt-24"
      (click)="fadeAndClose(fadeContainer)"
    >
      <p class="body large close">Close<i class="fa-light fa-xmark fa-xl cross ml-8"> </i></p>
    </app-button>
  </div>

  @if (sentImage()) {
    <img
      [src]="'data:' + sentImage().mimeType + ';base64,' + sentImage().data"
      class="attached-image-preview"
      [alt]="sentImage().filename"
    />
  }
</div>
